import fetcher from "./http";

import { buildQueryString } from "../../helpers";

export default {
    availableSchedulings(app_code, product_id, params) {
        return new Promise((resolve, reject) => {
            fetcher(
                `/${app_code}/products/${product_id}/available-schedulings?${buildQueryString(
                    params
                )}`,
                {
                    method: "GET",
                }
            )
                .then((response) => response.json())
                .then((data) => resolve(data))
                .catch((error) => reject(error));
        });
    },

    sellableProducts(app_code) {
        return new Promise((resolve, reject) => {
            fetcher(`/${app_code}/sellable-products`, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((data) => resolve(data))
                .catch((error) => reject(error));
        });
    },

    arrangedProducts(app_code, params = {}) {
        const queryString = buildQueryString(params);
        const url = queryString
            ? `/${app_code}/arranged-products?${queryString}`
            : `/${app_code}/arranged-products`;

        return new Promise((resolve, reject) => {
            fetcher(url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((data) => resolve(data))
                .catch((error) => reject(error));
        });
    },
};
